export const FILTER_OPTIONS = [
  { key: "bw", label: "B/W" },
  { key: "cool", label: "Cool" },
  { key: "warm", label: "Warm" },
  { key: "focus", label: "Focus" },
  { key: "teal_orange", label: "Teal & Orange" },
  { key: "vintage", label: "Vintage" },
  { key: "noir", label: "Noir" },
];

export const STRENGTH_OPTIONS = [
  { key: "subtle", label: "Subtle" },
  { key: "standard", label: "Standard" },
  { key: "strong", label: "Strong" },
];

const K = { subtle: 0.6, standard: 1.0, strong: 1.5 };
const n = (v) => Number(v.toFixed(3));

// Build the CSS look for a filter, dialled by strength (k). k=1 matches the baked "standard" render.
export function filterCss(filter, strength = "standard") {
  const k = K[strength] ?? 1.0;
  switch (filter) {
    case "bw":
      return `grayscale(${n(Math.min(1, 0.7 + 0.3 * k))}) contrast(${n(1 + 0.08 * k)})`;
    case "cool":
      return `sepia(${n(Math.min(1, 0.55 + 0.45 * k))}) saturate(${n(1 + 1.4 * k)}) hue-rotate(178deg) brightness(${n(1 - 0.04 * k)}) contrast(${n(1 + 0.06 * k)})`;
    case "warm":
      return `sepia(${n(Math.min(1, 0.2 + 0.4 * k))}) saturate(${n(1 + 0.9 * k)}) hue-rotate(-14deg) brightness(${n(1 + 0.05 * k)}) contrast(${n(1 + 0.03 * k)})`;
    case "noir":
      return `grayscale(1) contrast(${n(1 + 0.4 * k)}) brightness(1.02)`;
    case "vintage":
      return `sepia(${n(0.45 * k)}) saturate(${n(Math.max(0, 1 - 0.2 * k))}) contrast(${n(1 - 0.08 * k)}) brightness(${n(1 + 0.06 * k)})`;
    case "teal_orange":
      return `contrast(${n(1 + 0.1 * k)}) saturate(${n(1 + 0.35 * k)}) sepia(${n(0.18 * k)}) hue-rotate(-6deg)`;
    default:
      return "none";
  }
}

// Kept for any standard-strength consumers.
export const FILTER_CSS = {
  none: "none",
  bw: filterCss("bw"),
  cool: filterCss("cool"),
  warm: filterCss("warm"),
  noir: filterCss("noir"),
  vintage: filterCss("vintage"),
  teal_orange: filterCss("teal_orange"),
};

const FOCUS_MASK = "radial-gradient(ellipse 62% 58% at 50% 50%, #000 40%, rgba(0,0,0,0) 82%)";
const fill = { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" };

// Renders a slide image with the chosen colour/depth look + strength, matching the baked-in render.
export default function SlideFilteredImage({ src, filter = "none", strength = "standard", className = "", alt = "" }) {
  if (filter === "focus") {
    const k = K[strength] ?? 1.0;
    return (
      <>
        <img src={src} alt={alt} className={className} style={{ ...fill, filter: `blur(${n(2.5 * k)}px) saturate(${n(1 + 0.08 * k)})` }} />
        <img src={src} alt="" aria-hidden className={className} style={{ ...fill, WebkitMaskImage: FOCUS_MASK, maskImage: FOCUS_MASK }} />
      </>
    );
  }
  return <img src={src} alt={alt} className={className} style={{ filter: filterCss(filter, strength) }} />;
}
